import { useRouter } from 'next/navigation';

type UseSmartPrefetchProps = {
  href: string | null;
};

export function useSmartPrefetch({ href }: UseSmartPrefetchProps) {
  const router = useRouter();

  const prefetch = () => {
    if (!href) {
      return;
    }
    router.prefetch(href);
  };

  return {
    onMouseEnter: prefetch,
    onTouchStart: prefetch,
  };
}
